import * as React from 'react';
import { Paging } from './paging';
import { PagingArrows } from './paging-arrows';

interface IPaginationProps extends IPaginationOptions {
    onPageSelect(page: number): void;
}

export interface IPaginationOptions {
    totalItems: number;
    pageSize: number;
    pageNumber: number;
}

export interface IFullPaginationOptions extends IPaginationOptions {
    totalPages: number;
}

/// <summary>
/// Renders pagination arrows and buttons
/// </summary>
export class Pagination extends React.Component<IPaginationProps, any> {
    render() {
        let calculatedTotalPages = Math.ceil(this.props.totalItems / this.props.pageSize);
        let boundedCurrentPage = this.props.pageNumber > calculatedTotalPages
            ? calculatedTotalPages
            : this.props.pageNumber;

        let fullPaginationOptions = {
            totalItems: this.props.totalItems,
            pageSize: this.props.pageSize,
            pageNumber: boundedCurrentPage,
            totalPages: calculatedTotalPages
        }

        return (
            <nav className={"adage-search-pagination"} aria-label="adage-search-pagination">
                <ul className="adage-search-pagination-list adage-search-pagination-list-long">
                    <PagingArrows paging={fullPaginationOptions} isLeftArrows={true} onPageSelect={this.props.onPageSelect} />
                    <Paging paging={fullPaginationOptions} onPageSelect={this.props.onPageSelect} numberOfButtonsToShow={8} />
                    <PagingArrows paging={fullPaginationOptions} isLeftArrows={false} onPageSelect={this.props.onPageSelect} />
                </ul>
            </nav>
        );
    }
}
